import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Typography,
  Row,
  DatePicker,
  Col,
  Table,
  Button,
  Input,
  Empty,
  Card,
  List,
  Icon,
  message,
  Radio,
} from "antd";
import { platformApi } from "../../../../../api";
import AccessoryModal from "./AccessoryModal";
import VehicleModal from "./VehicleModal";
import moment from "moment";
import { formatVehicleName } from "../../../../../utils/vehicleDisplayName";
import {
  vehicleDataJoi,
  advancedVehicleDataJoi,
} from "../../BookingRegisterJoi";
import {
  generateErrorObj,
  defaultToNull,
  formatValue,
} from "../../../../../utils";

const { Text } = Typography;

const VehicleData = ({
  form,
  validityRef,
  clearRef,
  open,
  data,
  isSales,
  editable,
  mode,
  setCurrentBookingData,
}) => {
  const [initialAccessories, setInitialAccessories] = useState([]);
  const [manufacturerData, setManufacturerData] = useState([]);
  const [vehiclesData, setVehiclesData] = useState([]);
  const [colorData, setColorData] = useState([]);
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const [bookingAuthStatus, updateBookingAuthStatus] = useState(false);
  const [addFlag, setAddFlag] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [selected, setSelected] = useState(-1);
  const [vehiclePropsVisblity, toggleVehiclePropsVisiblity] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [accessoriesData, setAccessoriesData] = useState([]);
  const [dataColor, setDataColor] = useState([]);
  const [currentRto, setCurrentRto] = useState();
  const [rtoData, setRtoData] = useState([]);
  const insTypes = [
    { key: "insurance1plus5", title: "1+5" },
    { key: "insurance5plus5", title: "5+5" },
    { key: "insurance1plus5ZD", title: "1+5 Zero Dep" },
    { key: "insurance5plus5ZD", title: "5+5 Zero Dep" },
  ];
  const [selectedz, setSelectedz] = useState(-1);
  const [chooseModalFlag, setChooseModalFlag] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState([]);
  const [accTotal, setAccTotal] = useState(0);
  const [errorObj, setErrorObj] = useState({});
  const [rsa, SetRsa] = useState(0);
  const [amc, SetAmc] = useState(0);
  const [bhSeries, setBhSeries] = useState(null);
  const [specialNo, setSpecialNo] = useState(null);

  const filterMethod = (input, option) =>
    option.props.children
      .toString()
      .toLowerCase()
      .indexOf(input.toLowerCase()) >= 0;

  const addVehicle = (vehicle) => {
    const expectedDate = form.getFieldValue("expectedDeliveryDate") || null;
    setSelectedVehicle([{ ...vehicle, expectedDeliveryDate: expectedDate }]);
    if (vehicle.optionalType) {
      SetRsa(
        (vehicle.optionalType.length > 0 &&
          parseFloat(vehicle.optionalType[0] & vehicle.optionalType[0].amount)) || 0
      );
      SetAmc(
        (vehicle.optionalType.length > 0 &&
          parseFloat(vehicle.optionalType[1] && vehicle.optionalType[1].amount)) || 0
      );
    }
    data.vehiclePrice = vehicle?.price;
    // Always take price master fields from vehicle.price (not old data.price).
    // Old data.price may have roadTaxBHSeries:0 from a previous selection/revert
    // which would silently override the correct vehicle price value.
    const vp = vehicle?.price || {};
    data.price = {
      ...(data.price || {}),
      roadTax: vp.roadTax || 0,
      roadTaxBHSeries: vp.roadTaxBHSeries || 0,
      showroomPrice: vp.showroomPrice || 0,
      registrationFee: vp.registrationFee || 0,
      handlingCharges: vp.handlingCharges || 0,
      warrantyPrice: vp.warrantyPrice || 0,
      tcs: vp.tcs || 0,
      insuranceAmount: vp.insuranceAmount || 0,
    };
    data.insuranceAmount = vehicle?.insuranceType?.[0]?.amount || 0;
    setFieldsValue({
      insuranceType: vehicle.insuranceType[0] ? vehicle.insuranceType[0].type : undefined,
      onRoadPrice:
        (vehicle.insuranceType.length > 0 && String(vehicle.insuranceType[0].onRoad)) || "0",
    });
    // Recalculate Final Amount with existing additions/discount (same as BH series path)
    addFinalAmount({ target: { value: 0 } });
  };

  const removeSelectedVehicle = (index) => {
    selectedVehicle.splice(index, 1);
    setSelectedVehicle([...selectedVehicle]);
    setFieldsValue({ insuranceType: undefined, onRoadPrice: undefined });
  };

  const summaryColumns = [
    {
      title: "Accessory",
      dataIndex: "partName",
      key: "name",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (text, row) => <span>{row.quantity || 1}</span>,
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
      render: (discount, row) => (
        <span>
          {discount} {row.isPercent ? "%" : "Rs."}
        </span>
      ),
    },
    {
      title: "Price before Discount",
      dataIndex: "mrp",
      key: "price",
      render: (text, row) => {
        const quantity = row.quantity || 1;
        return <span>{(text * quantity).toFixed(2)}</span>;
      },
    },
    {
      title: "Price after Discount",
      key: "discountPrice",
      render: (_, row) => {
        const { mrp, discount, isPercent, quantity = 1 } = row;
        const discountedPrice = isPercent ? mrp - (mrp * discount) / 100 : mrp - discount;
        const total = discountedPrice * quantity;
        return <span>{total < 0 ? 0 : total.toFixed(2)}</span>;
      },
    },
  ];

  const getVehicleModalData = () => {
    // vehicleDetail.price is the raw VehiclePrice array from mapBooking.
    const vehicleDetailPrice = selectedVehicle[0]?.vehicleDetail?.price;
    const latestVehiclePrice = Array.isArray(vehicleDetailPrice)
      ? ([...vehicleDetailPrice].reverse().find((p) => p.roadTaxBHSeries && Number(p.roadTaxBHSeries) > 0) || vehicleDetailPrice[vehicleDetailPrice.length - 1] || vehicleDetailPrice[0])
      : vehicleDetailPrice;

    const fallbackRoadTaxBHSeries =
      (data.price?.roadTaxBHSeries && Number(data.price.roadTaxBHSeries) !== 0)
        ? Number(data.price.roadTaxBHSeries)
        : (latestVehiclePrice?.roadTaxBHSeries ? Number(latestVehiclePrice.roadTaxBHSeries) : 0);

    const priceWithInsurance = {
      ...data.price,
      roadTaxBHSeries: fallbackRoadTaxBHSeries,
      colors: [
        {
          imageDetails: [
            {
              id: data.color?.id || "default",
              url: data.color?.url || "",
              color: data.color?.color || "",
            },
          ],
        },
      ],
    };
    if (data.price?.insuranceType && data.price?.insuranceAmount !== undefined) {
      priceWithInsurance[data.price.insuranceType] = data.price.insuranceAmount;
    }
    return {
      ...selectedVehicle[0],
      price: priceWithInsurance,
      insuranceType: [
        {
          type: data?.price?.insuranceType || "",
          amount: data?.price?.insuranceAmount || "",
          onRoad: data?.price?.roadTax || "",
          handlingCharges: data?.latestPriceDetails?.handlingCharges || "",
        },
      ],
    };
  };

  const column = [
    {
      title: "Accessory",
      dataIndex: "partName",
      key: "name",
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (text) => <span>{text || 1}</span>,
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
      render: (record, row) => (
        <span>
          {record} {row.isPercent ? "%" : "Rs."}
        </span>
      ),
    },
    {
      title: "Price before Discount",
      dataIndex: "mrp",
      key: "price",
      render: (record, row) => {
        const quantity = row.quantity || 1;
        return <span>{(record * quantity).toFixed(2)}</span>;
      },
    },
    {
      title: "Price after Discount",
      dataIndex: "mrp",
      key: "discountPrice",
      render: (record, row) => {
        const quantity = row.quantity || 1;
        const discount = row.discount || 0;
        let Rs_dis = record - discount < 0 ? 0 : record - discount;
        let Pr_dis =
          record - (record * (discount / 100)).toFixed(2) < 0
            ? 0
            : record - (record * (discount / 100)).toFixed(2);
        let dis_data = row.isPercent ? Pr_dis : Rs_dis;
        return <span>{(dis_data * quantity).toFixed(2)}</span>;
      },
    },
  ];

  useEffect(() => {
    clearRef.current = () => {
      form.resetFields();
      setSelectedVehicle([]);
      setDataSource([]);
      setSelectedz(null);
      setBhSeries(null);
      setSpecialNo(null);
    };
    validityRef.current = () => validatePage();
    // ← NO cleanup that nulls the refs
  });

  useEffect(() => {
    toggleVehiclePropsVisiblity(!(selectedVehicle.length > 0));
  }, [selectedVehicle]);

  // Re-populate specialNoRemarks once the textarea is mounted (i.e. specialNo becomes true).
  // Without this, setFieldsValue runs before the field exists in the DOM and the value is lost.
  useEffect(() => {
    if (specialNo === true && data?.specialNoRemarks) {
      setFieldsValue({ specialNoRemarks: data.specialNoRemarks });
    }
  }, [specialNo]);

  // Handle BH Series change only when the user explicitly clicks Yes or No
  const handleBhSeriesChange = (newValue) => {
    const oldValue = bhSeries;
    setBhSeries(newValue);

    if (selectedVehicle.length > 0 && selectedVehicle[0]?.price) {
      const vehiclePrice = selectedVehicle[0].price;
      const roadTaxNormal = parseFloat(vehiclePrice.roadTax || 0);
      const roadTaxBH = parseFloat(vehiclePrice.roadTaxBHSeries || 0);
      const currentOnRoad = parseFloat(getFieldValue("onRoadPrice") || 0);

      if (oldValue !== true && newValue === true) {
        // Switched from Normal to BH: remove normal road tax, add BH series road tax
        const newOnRoad = currentOnRoad - roadTaxNormal + roadTaxBH;
        setFieldsValue({ onRoadPrice: String(newOnRoad) });
        addFinalAmount({ target: { value: 0 } });
      } else if (oldValue === true && newValue === false) {
        // Switched from BH to Normal: remove BH series road tax, add normal road tax
        const newOnRoad = currentOnRoad - roadTaxBH + roadTaxNormal;
        setFieldsValue({ onRoadPrice: String(newOnRoad) });
        addFinalAmount({ target: { value: 0 } });
      }
    }
  };

  useEffect(() => {
    if (isSales) {
      if (data?.vehicle && data.vehicle.manufacturer) {
        setManufacturerData([data.vehicle.manufacturer]);
      }
      if (data?.vehicle) {
        setVehiclesData([
          {
            ...data.vehicle,
            modelCode: data.vehicle.modelCode || data.vehicle.modelName || "",
          },
        ]);
      }
      if (data.selectedVehicle) {
        let selectedVehicleArr = [];
        if (typeof data.selectedVehicle === "string") {
          try {
            selectedVehicleArr = JSON.parse(data.selectedVehicle);
          } catch (e) {
            selectedVehicleArr = [];
          }
        } else {
          selectedVehicleArr = data.selectedVehicle;
        }
        setSelectedVehicle(selectedVehicleArr);
        setColorData(selectedVehicleArr.map((v) => v.color));
      }
      if (data.rto) {
        setRtoData([data.rto]);
        setCurrentRto(data.rto);
      }
      setFieldsValue({
        manufacturer: data.vehicle?.manufacturer?.id,
        model: data.vehicle?.id,
        rto: data.rto?.id,
        numberPlate: data.price?.numberPlate?.toString() || "",
        affidavitAmount: data.price?.affidavit?.toString() || "",
        TRcharges: data.price?.tempRegister?.toString() || "",
        hypothetication: data.price?.hp?.toString() || "",
        insuranceType: data.price?.insuranceType,
        specialNoCharges: data.price?.specialNoCharges?.toString() || "",
        onRoadDiscount: data.price?.onRoadDiscount?.toString() || "",
        onRoadPrice: data.price?.onRoadPrice?.toString() || "",
        vehicleModel: data.exchange?.vehicleModel,
        vehiclePrice: data.exchange?.vehiclePrice?.toString() || "",
        totalDiscount: data.price?.totalDiscount ? Number(parseFloat(data.price.totalDiscount).toFixed(3)).toString() : "",
        accessoriesTotal: data.price?.accessoriesTotal ? Number(parseFloat(data.price.accessoriesTotal).toFixed(3)).toString() : "",
        accessoriesTotalAfterDiscount: data.price?.accessoriesTotalAfterDiscount ? Number(parseFloat(data.price.accessoriesTotalAfterDiscount).toFixed(3)).toString() : "",
        finalAmount: data.price?.finalAmount?.toString() || "",
        chassisNumber: data.chassisNumber || "",
        specialNoRemarks: data.specialNoRemarks || "",
        expectedDeliveryDate: data.expectedDeliveryDate
          ? moment(data.expectedDeliveryDate)
          : null,
      });
      setBhSeries(data.bhSeries ?? null);
      setSpecialNo(data.specialNo ?? null);
      if (data.accessories && data.accessories.length > 0) {
        setDataSource(data.accessories);
        setInitialAccessories(data.accessories);
      }
      updateBookingAuthStatus(data.authentication?.verifiedAt || false);
      if (data.vehicle && data.vehicle.manufacturer && data.vehicle.id) {
        setDataColor([
          { manufacturer: data.vehicle.manufacturer.id },
          { model: data.vehicle.id },
        ]);
      }
      return;
    }
    if (open) {
      platformApi
        .post(`/api/options/get/`, {
          module: "rtoes",
          searchString: "",
          column: "code",
          fields: ["area"],
          page: 1,
          size: 20,
        })
        .then((res) => {
          setRtoData(res.data.response);
          if (data.rto?.id) {
            setCurrentRto(res.data.response.find((d) => d.id == data.rto?.id));
            setFieldsValue({ rto: data.rto.id });
          }
        });

      setSelectedz(0);
      setManufacturerData(getManufacturers(data.branch && data.branch.id));
      if (data.selectedVehicle && Array.isArray(data.selectedVehicle)) {
        setSelectedVehicle(data.selectedVehicle);
        setColorData(data.selectedVehicle.map((v) => v.color));
      } else if (data.vehicle && data.vehicle.color) {
        setSelectedVehicle([{ color: data.vehicle.color }]);
        setColorData([data.vehicle.color]);
      }
      if (data.vehicle && data.vehicle.manufacturer && data.vehicle.id) {
        setDataColor([
          { manufacturer: data.vehicle.manufacturer.id },
          { model: data.vehicle.id },
        ]);
      }
      if (data.price) {
        setFieldsValue({
          numberPlate: data.price.numberPlate?.toString() || "",
          affidavitAmount: data.price.affidavit?.toString() || "",
          TRcharges: data.price.tempRegister?.toString() || "",
          hypothetication: data.price.hp?.toString() || "",
          insuranceType: data.price.insuranceType,
          specialNoCharges: data.price.specialNoCharges?.toString() || "",
          onRoadDiscount: data.price.onRoadDiscount?.toString() || "",
          onRoadPrice: data.price.onRoadPrice?.toString() || "",
          vehicleModel: data.exchange?.vehicleModel,
          vehiclePrice: data.exchange?.vehiclePrice?.toString() || "",
          totalDiscount: data.price.totalDiscount ? Number(parseFloat(data.price.totalDiscount).toFixed(3)).toString() : "",
          accessoriesTotal: data.price.accessoriesTotal ? Number(parseFloat(data.price.accessoriesTotal).toFixed(3)).toString() : "",
          accessoriesTotalAfterDiscount: data.price.accessoriesTotalAfterDiscount ? Number(parseFloat(data.price.accessoriesTotalAfterDiscount).toFixed(3)).toString() : "",
          finalAmount: data.price.finalAmount?.toString() || "",
          chassisNumber: data.chassisNumber || "",
          specialNoRemarks: data.specialNoRemarks || "",
        });
      }
      setBhSeries(data.bhSeries ?? null);
      setSpecialNo(data.specialNo ?? null);
      if (data.expectedDeliveryDate) {
        setFieldsValue({
          expectedDeliveryDate: moment(data.expectedDeliveryDate),
        });
      }
      if (data.accessories && data.accessories.length > 0) {
        setDataSource(data.accessories);
        setInitialAccessories(data.accessories);
      }
    }
  }, [open, data]);

  const validateOnBlur = () => {
    let vehicleValidation;
    if (mode == "ConfirmBooking") {
      vehicleValidation = vehicleDataJoi(defaultToNull(form.getFieldsValue()));
    } else {
      vehicleValidation = advancedVehicleDataJoi(defaultToNull(form.getFieldsValue()));
    }
    if (vehicleValidation.error) {
      let generatedError = generateErrorObj(vehicleValidation, {});
      setErrorObj(generatedError);
    } else {
      setErrorObj({});
    }
  };

  useEffect(() => {
    if (data.price) {
      setFieldsValue({
        totalDiscount: data.price.totalDiscount ? Number(parseFloat(data.price.totalDiscount).toFixed(3)).toString() : "0",
        accessoriesTotal: data.price.accessoriesTotal ? Number(parseFloat(data.price.accessoriesTotal).toFixed(3)).toString() : "0",
        accessoriesTotalAfterDiscount: data.price.accessoriesTotalAfterDiscount ? Number(parseFloat(data.price.accessoriesTotalAfterDiscount).toFixed(3)).toString() : "0",
      });
    }
    if (data.accessories && data.accessories.length > 0) {
      setDataSource(data.accessories);
      setInitialAccessories(data.accessories);
    }
    addFinalAmount({ target: { value: accTotal } });
  }, [accTotal]);

  const validatePage = () => {
    let isValid = true;

    if (editable) {
      form.validateFields((validationError) => {
        isValid = validationError === null;

        let vehicleValidation;
        let fields = defaultToNull(form.getFieldsValue());

        // ── Convert moment → ISO string for Joi; keep null if absent ──
        if (fields.expectedDeliveryDate) {
          if (moment.isMoment(fields.expectedDeliveryDate)) {
            fields.expectedDeliveryDate = fields.expectedDeliveryDate.format("YYYY-MM-DD");
          }
        } else {
          fields.expectedDeliveryDate = null;
        }

        if (mode === "ConfirmBooking") {
          vehicleValidation = vehicleDataJoi(fields);
        } else {
          vehicleValidation = advancedVehicleDataJoi(fields);
        }

        if (vehicleValidation.error) {
          setErrorObj(generateErrorObj(vehicleValidation, errorObj));
          isValid = false;
        }
      });
    } else {
      isValid = true;
    }

    if (isValid) {
      const formValues = form.getFieldsValue();
      const rawDate = formValues.expectedDeliveryDate;
      const expectedDeliveryDateISO = rawDate
        ? moment.isMoment(rawDate)
          ? rawDate.toISOString()
          : rawDate
        : null;

      data.rto = currentRto;
      data.price = {
        ...(data.price || {}),
        numberPlate: parseFloat(formValues.numberPlate) || 0,
        affidavit: parseFloat(formValues.affidavitAmount) || 0,
        tempRegister: parseFloat(formValues.TRcharges) || 0,
        hp: parseFloat(formValues.hypothetication) || 0,
        insuranceType: formValues.insuranceType,
        specialNoCharges: parseFloat(formValues.specialNoCharges) || 0,
        onRoadDiscount: parseFloat(formValues.onRoadDiscount) || 0,
        onRoadPrice: parseFloat(formValues.onRoadPrice) || 0,
        totalDiscount: parseFloat(formValues.totalDiscount) || 0,
        accessoriesTotal: parseFloat(formValues.accessoriesTotal) || 0,
        accessoriesTotalAfterDiscount: parseFloat(formValues.accessoriesTotalAfterDiscount) || 0,
        finalAmount: parseFloat(formValues.finalAmount) || 0,
      };

      data.exchange = {
        vehicleModel: formValues.vehicleModel,
        vehiclePrice: parseFloat(formValues.vehiclePrice) || 0,
      };

      // Always sync netRecieveables into the shared data object before leaving
      // this tab. If the user clicks "Next" without blurring the Exchange Price
      // field, onBlur never fires, leaving data.price.netRecieveables stale.
      const finalAmtForNet = parseFloat(formValues.finalAmount) || 0;
      updateNetReceivables(finalAmtForNet);

      const updatedSelectedVehicle = selectedVehicle.map((v) => ({
        ...v,
        expectedDeliveryDate: expectedDeliveryDateISO,
      }));

      data.selectedVehicle = updatedSelectedVehicle;
      data.expectedDeliveryDate = expectedDeliveryDateISO;

      if (updatedSelectedVehicle.length > 0) {
        data.vehicle = updatedSelectedVehicle[0].vehicleDetail || updatedSelectedVehicle[0];
      }

      data.chassisNumber = formValues.chassisNumber;
      data.bhSeries = bhSeries;
      data.specialNo = specialNo;
      data.specialNoRemarks = specialNo ? (formValues.specialNoRemarks || null) : null;

      if (typeof setCurrentBookingData === "function") {
        setCurrentBookingData((prev) => ({
          ...prev,
          selectedVehicle: updatedSelectedVehicle,
          expectedDeliveryDate: expectedDeliveryDateISO,
        }));
      }
    }

    return isValid;
  };

  const getManufacturers = (branchId) => {
    platformApi.get(`/api/manufacturer/branch/${branchId}`).then((res) => {
      let { data: resData } = res;
      if (resData.code === 200) {
        let { response } = resData;
        if (response.code === 200) {
          let selectedManId =
            (data.vehicle && data.vehicle.manufacturer.id) ||
            response.data.manufacturer[0].id;
          form.setFieldsValue({ manufacturer: selectedManId });
          manufacturerSelect(selectedManId);
          dataColor[0] = { manufacturer: selectedManId };
          setManufacturerData(response.data.manufacturer);
        }
      }
    });
    return [];
  };

  const manufacturerSelect = (id) => {
    platformApi.get(`/api/vehicleMaster/man/${id}?onlyAvailable=1`).then((res) => {
      let { data: resData } = res;
      if (resData.code === 200) {
        let { response } = resData;
        if (response.code === 200) {
          const models = response.data.filter(
            (model) => model.vehicleStatus === "AVAILABLE" && model.price[0]
          );
          setVehiclesData(models);
        }
      }
    });
    form.setFieldsValue({ model: (data.vehicle && data.vehicle.id) || undefined });
  };

  const modelSelect = (id) => {
    platformApi.get(`/api/vehicleMaster/${id}`).then((res) => {
      let { data: resData } = res;
      if (resData.code === 200) {
        let { response } = resData;
        if (response.code === 200) {
          const vmImages = response.data.image || [];

          // Collect all colorIds selected across all VP records for this model
          const vpColorIds = new Set(
            (response.data.price || [])
              .flatMap(p => p.colors || [])
              .map(c => c.colorId)
              .filter(Boolean)
          );

          // Show only VM colors that are linked (selected) in VP
          const filteredColors = vpColorIds.size > 0
            ? vmImages.filter(img => vpColorIds.has(img.id))
            : []; // fallback: show all VM colors if no VP is set up yet

          setColorData(filteredColors);
          setSelectedz(0);
        }
      }
    });
  };

  const addData = (accesoriesArr) => {
    let totalDiscount = 0;
    let totalAccesory = 0;
    accesoriesArr?.forEach((obj) => {
      const quantity = obj.quantity || 1;
      const mrp = obj.mrp || 0;
      const itemTotal = mrp * quantity;
      obj.discount = isNaN(obj.discount) ? 0 : Number(obj.discount);
      const itemDiscount = obj.isPercent
        ? itemTotal * (obj.discount / 100)
        : obj.discount * quantity;
      totalDiscount += itemDiscount;
      totalAccesory += itemTotal;
    });
    setFieldsValue({
      totalDiscount: totalDiscount ? Number(parseFloat(totalDiscount).toFixed(3)).toString() : "0",
      accessoriesTotal: totalAccesory ? Number(parseFloat(totalAccesory).toFixed(3)).toString() : "0",
      accessoriesTotalAfterDiscount: (totalAccesory - totalDiscount)
        ? Number(parseFloat(totalAccesory - totalDiscount).toFixed(3)).toString()
        : "0",
    });
    data.price = {
      ...data.price,
      totalDiscount: totalDiscount || 0,
      accessoriesTotal: totalAccesory || 0,
      accessoriesTotalAfterDiscount: totalAccesory - totalDiscount || 0,
    };
    data.accessories = accesoriesArr || [];
    setDataSource(accesoriesArr || []);
    setInitialAccessories(accesoriesArr || []);
    let e = { target: { value: totalAccesory - totalDiscount } };
    setAccTotal(parseFloat(totalAccesory - totalDiscount));
    addFinalAmount(e);
  };

  const setAccessories = () => {
    let modelId = getFieldValue("model");
    if (modelId) {
      platformApi.get(`/api/partsMaster/Cloudsuit/${modelId}`).then((res) => {
        let { data: resData } = res;
        if (resData.code === 200) {
          let { response } = resData;
          if (response.code === 200) {
            let newArr = [];
            for (let i = 0; i < response.data.length; i++) {
              const element = response.data[i];
              if (element.mainPartNumber) {
                if (!newArr.some((item) => item.mainPartNumber === element.mainPartNumber)) {
                  newArr.push(element);
                }
              } else {
                newArr.push(element);
              }
            }
            newArr.forEach((item) => {
              item.checked = false;
              item.arrayId = "";
              item.discount = 0;
              item.isPercent = false;
            });
            for (let i = 0; i < newArr.length; i++) {
              for (let j = 0; j < dataSource.length; j++) {
                if (dataSource[j].id === newArr[i].id) {
                  newArr[i].discount = dataSource[j].discount || 0;
                  newArr[i].isPercent = dataSource[j].isPercent === true;
                  newArr[i].checked = true;
                  newArr[i].arrayId = dataSource[j].arrayId || "";
                  break;
                }
              }
            }
            setAccessoriesData(newArr);
          }
        }
      });
    }
  };

  const addFinalAmount = (event) => {
    let value = event.target.value;
    if (value === "") value = 0;
    let affidavitAmount = parseFloat(!isNaN(getFieldValue("affidavitAmount")) ? getFieldValue("affidavitAmount") : 0);
    let TRcharges = parseFloat(!isNaN(getFieldValue("TRcharges")) ? getFieldValue("TRcharges") : 0);
    let specialNoCharges = parseFloat(!isNaN(getFieldValue("specialNoCharges")) ? getFieldValue("specialNoCharges") : 0);
    let hypothetication = parseFloat(!isNaN(getFieldValue("hypothetication")) ? getFieldValue("hypothetication") : 0);
    let onRoadDiscount = parseFloat(!isNaN(getFieldValue("onRoadDiscount")) ? getFieldValue("onRoadDiscount") : 0);
    let numCharges = parseFloat(!isNaN(getFieldValue("numberPlate")) ? getFieldValue("numberPlate") : 0);
    let onRoadPrice = parseFloat(!isNaN(getFieldValue("onRoadPrice")) ? getFieldValue("onRoadPrice") : 0);
    let accessoriesTotalAfterDiscount = parseFloat(
      !isNaN(getFieldValue("accessoriesTotalAfterDiscount"))
        ? getFieldValue("accessoriesTotalAfterDiscount")
        : 0
    );
    const finalAmountValue =
      (isNaN(accessoriesTotalAfterDiscount) ? 0 : accessoriesTotalAfterDiscount) +
      (isNaN(affidavitAmount) ? 0 : affidavitAmount) +
      (isNaN(TRcharges) ? 0 : TRcharges) +
      (isNaN(specialNoCharges) ? 0 : specialNoCharges) +
      (isNaN(hypothetication) ? 0 : hypothetication) +
      (isNaN(numCharges) ? 0 : numCharges) +
      (isNaN(onRoadPrice) ? 0 : onRoadPrice) -
      (isNaN(onRoadDiscount) ? 0 : onRoadDiscount);
    setFieldsValue({ finalAmount: String(finalAmountValue) });
    if (data.price) data.price.finalAmount = finalAmountValue;
    updateNetReceivables(finalAmountValue);
  };

  const updateNetReceivables = (finalAmountValue) => {
    const exchangePrice = parseFloat(getFieldValue("vehiclePrice") || 0);
    const paymentMode = data.price?.paymentMode || "cash";
    const loanType = data.loan?.loanType || "self";
    let netReceivables = finalAmountValue - exchangePrice;
    if (paymentMode === "finance" && loanType === "companyAssist") {
      netReceivables =
        Number(data?.price?.finalAmount) - Number(data?.loan?.disbursementAmount);
    }
    if (data.price) data.price.netRecieveables = netReceivables;
    return netReceivables;
  };

  const handleChargeFieldChange = (fieldName, value) => {
    validateOnBlur();
    addFinalAmount({ target: { value: 0 } });
  };

  return (
    <Form style={{ marginTop: "4%", marginBottom: "4%" }}>
      <Row type="flex" justify="space-between">
        <Col span={15}>
          <Row type="flex" justify="space-between">
            <Col span={11}>
              <Form.Item colon={false} required={true} label={<Text>Manufacturer</Text>}>
                {getFieldDecorator("manufacturer", {
                  rules: [{ required: true, message: "Manufacturer Required!" }],
                })(
                  <Select
                    placeholder="Manufacturer"
                    onSelect={(id) => {
                      manufacturerSelect(id);
                      setColorData([]);
                      setSelectedVehicle([]);
                      setFieldsValue({});
                      dataColor[0] = { manufacturer: id };
                    }}
                    disabled={!editable || bookingAuthStatus}
                  >
                    {manufacturerData?.map((data) => (
                      <Select.Option key={data.id}>{data.name}</Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col span={11}>
              <Form.Item colon={false} required={true} label={<Text>Model Name</Text>}>
                {getFieldDecorator("model", {
                  rules: [{ required: true, message: "Please input your Model Name!" }],
                })(
                  <Select
                    className="vehicle-select"
                    disabled={
                      !getFieldValue("manufacturer") ||
                      vehiclesData.length === 0 ||
                      !editable ||
                      bookingAuthStatus
                    }
                    placeholder="Model Name"
                    onSelect={(id) => {
                      modelSelect(id);
                      setSelectedVehicle([]);
                      setFieldsValue({});
                      dataColor[1] = { model: id };
                    }}
                    showAction={["click", "focus"]}
                    showSearch
                    filterOption={filterMethod}
                  >
                    {vehiclesData?.map((data) => (
                      <Select.Option key={data.id}>
                        {formatVehicleName(data)}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
          {/* Hidden insuranceType — keeps decorator registered without layout space */}
          <div style={{ display: "none" }}>
            <Form.Item>
              {getFieldDecorator("insuranceType", { rules: [{ required: false }] })(
                <Select>
                  {insTypes?.map((d) => (
                    <Select.Option key={d.key}>{d.title}</Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </div>

          {/* Row 2: RTO | [BH Series (no chassis)] or [Chassis Number (chassis)] */}
          <Row type="flex" justify="space-between">
            <Col span={11}>
              <Form.Item
                required={mode === "ConfirmBooking"}
                colon={false}
                label={<Text>RTO</Text>}
              >
                {getFieldDecorator("rto", {
                  rules: [
                    {
                      required: mode === "ConfirmBooking",
                      message: "Please input RTO Name!",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    showAction={["click", "focus"]}
                    disabled={!editable || bookingAuthStatus}
                    placeholder="Select RTO"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      const childText = option.props.children.join(" ").toLowerCase();
                      return childText.indexOf(input.toLowerCase()) >= 0;
                    }}
                    onChange={(d) => {
                      setCurrentRto(rtoData.find((r) => r.id === d));
                    }}
                  >
                    {rtoData?.map((d) => (
                      <Select.Option key={d.id}>
                        {d.code} - {d.area}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>

            {/* Right col: BH Series (no chassis) OR Chassis Number (chassis allocated) */}
            <Col span={11}>
              {!data.chassisNumber ? (
                <Form.Item colon={false} label={<Text>BH Series</Text>}>
                  <Radio.Group
                    value={bhSeries}
                    onChange={(e) => handleBhSeriesChange(e.target.value)}
                    disabled={!editable || bookingAuthStatus}
                  >
                    <Radio value={true}>Yes</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              ) : (
                <Form.Item colon={false} label={<Text>chassis Number</Text>}>
                  {getFieldDecorator("chassisNumber", {
                    initialValue: data.chassisNumber || "",
                    rules: [{ required: true, message: "Please input Chassis Number!" }],
                  })(
                    <Input
                      disabled={!editable || bookingAuthStatus}
                      placeholder="Enter Chassis Number"
                    />
                  )}
                </Form.Item>
              )}
            </Col>
          </Row>

          {/* Row 3 (chassis allocated only): BH Series | Special No */}
          {data.chassisNumber && (
            <Row type="flex" justify="start" style={{ gap: "60px" }}>
              <Col>
                <Form.Item colon={false} label={<Text>BH Series</Text>}>
                  <Radio.Group
                    value={bhSeries}
                    onChange={(e) => handleBhSeriesChange(e.target.value)}
                    disabled={!editable || bookingAuthStatus}
                  >
                    <Radio value={true}>Yes</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item colon={false} label={<Text>Special No</Text>}>
                  <Radio.Group
                    value={specialNo}
                    onChange={(e) => setSpecialNo(e.target.value)}
                    disabled={!editable || bookingAuthStatus}
                  >
                    <Radio value={true}>Yes</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              {specialNo === true && (
                <Col style={{ width: "300px" }}>
                  <Form.Item colon={false} required={true} label={<Text>Special No Remarks</Text>}>
                    {getFieldDecorator("specialNoRemarks", {
                      rules: [{ required: true, message: "Please enter remarks for Special No!" }],
                    })(
                      <Input.TextArea
                        rows={3}
                        disabled={!editable || bookingAuthStatus}
                        placeholder="Enter special number remarks"
                      />
                    )}
                  </Form.Item>
                </Col>
              )}
            </Row>
          )}

          {/* Row 3 (no chassis): Special No | Remarks (if Yes) */}
          {!data.chassisNumber && (
            <Row type="flex" justify="start" style={{ gap: "16px" }}>
              <Col>
                <Form.Item colon={false} label={<Text>Special No</Text>}>
                  <Radio.Group
                    value={specialNo}
                    onChange={(e) => setSpecialNo(e.target.value)}
                    disabled={!editable || bookingAuthStatus}
                  >
                    <Radio value={true}>Yes</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              {specialNo === true && (
                <Col style={{ width: "300px" }}>
                  <Form.Item colon={false} required={true} label={<Text>Special No Remarks</Text>}>
                    {getFieldDecorator("specialNoRemarks", {
                      rules: [{ required: true, message: "Please enter remarks for Special No!" }],
                    })(
                      <Input.TextArea
                        rows={3}
                        disabled={!editable || bookingAuthStatus}
                        placeholder="Enter special number remarks"
                      />
                    )}
                  </Form.Item>
                </Col>
              )}
            </Row>
          )}

        </Col>
        <Col span={7}>
          <Form.Item
            required={true}
            label={
              <Text>
                Vehicle Color
              </Text>
            }
            colon={false}
          >
            {Array.isArray(selectedVehicle) &&
              selectedVehicle.length > 0 &&
              selectedVehicle[0]?.color ? (
              selectedVehicle.map((vehicle, index) => (
                <List
                  key={index}
                  dataSource={selectedVehicle}
                  renderItem={(model) => (
                    <Card
                      style={{ width: "100%" }}
                      onClick={() => {
                        setSelectedz(0);
                        setChooseModalFlag(true);
                      }}
                      size="small"
                      hoverable={true}
                      cover={
                        <span>
                          <img
                            width="100%"
                            style={{ objectFit: "contain", height: "calc(25vw*9/40)" }}
                            alt={
                              selectedVehicle?.[0]?.color?.color ||
                              model?.color?.colorName ||
                              "vehicle color"
                            }
                            src={
                              selectedVehicle?.[0]?.color?.url ||
                              model?.color?.imageDetails?.[0]?.url ||
                              ""
                            }
                          />
                        </span>
                      }
                    >
                      <Card.Meta
                        title={
                          <Text strong style={{ alignItems: "center" }}>
                            {selectedVehicle?.[0]?.color?.color || model?.color?.colorName}-
                            {model?.color?.imageDetails?.[0]?.code ||
                              selectedVehicle?.[0]?.color?.code ||
                              "ColorCode"}
                            {editable ||
                              (!bookingAuthStatus && (
                                <span>
                                  <Icon
                                    type="close"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeSelectedVehicle(index);
                                    }}
                                  />
                                </span>
                              ))}
                          </Text>
                        }
                      />
                    </Card>
                  )}
                />
              ))
            ) : (
              <Empty
                imageStyle={{ height: 20, fontSize: 20 }}
                description={<Text disabled strong>No Vehicle Chosen</Text>}
                image={<Icon theme="twoTone" twoToneColor="#BDBDBD" type="container" />}
              />
            )}
          </Form.Item>
          <br />
          <Form.Item>
            <Button
              onClick={() => setChooseModalFlag(true)}
              disabled={!editable || colorData.length === 0 || bookingAuthStatus}
            >
              Select Vehicle Color
            </Button>
          </Form.Item>
        </Col>
      </Row>
      <br />
      <Table
        rowKey={(record) => record.id}
        pagination={{ pageSize: 3 }}
        columns={column}
        style={{ cursor: "pointer" }}
        tableLayout="auto"
        dataSource={dataSource}
      />
      <Row type="flex">
        <Form.Item style={{ marginLeft: "auto" }} colon={false} label={<Text>Total Discount</Text>}>
          {getFieldDecorator("totalDiscount")(
            <Input addonBefore="&#8377;" disabled={true} placeholder="Total Discount" />
          )}
        </Form.Item>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <Form.Item colon={false} label={<Text>Accessories Total</Text>}>
          {getFieldDecorator("accessoriesTotal")(
            <Input addonBefore="&#8377;" disabled={true} placeholder="Accessories Total" />
          )}
        </Form.Item>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <Form.Item colon={false} label={<Text>Accessories Total (after Discount)</Text>}>
          {getFieldDecorator("accessoriesTotalAfterDiscount")(
            <Input
              addonBefore="&#8377;"
              disabled={true}
              placeholder="Accessories Total(after Discount)"
            />
          )}
        </Form.Item>
      </Row>
      <br />
      <Row type="flex" justify="space-between">
        <Button
          onClick={() => {
            setAddFlag(true);
            setEditFlag(true);
            setAccessories();
          }}
          type="primary"
          disabled={!editable || vehiclePropsVisblity || bookingAuthStatus}
          style={{ marginLeft: "auto" }}
        >
          Add/Modify Accessory
        </Button>
      </Row>
      <br />
      <Text strong>Exchange Vehicle Information</Text>
      <Row type="flex" justify="space-between">
        <Col span={7}>
          <Form.Item
            validateStatus={errorObj && errorObj.vehicleModel ? "error" : ""}
            help={errorObj && errorObj.vehicleModel}
            colon={false}
            label={<Text>Exchange Model Name</Text>}
          >
            {getFieldDecorator("vehicleModel", {
              rules: [{ required: false, message: "Please input your Model Name!" }],
            })(
              <Input
                disabled={!editable || vehiclePropsVisblity || bookingAuthStatus}
                placeholder="Exchange Vehicle"
                onBlur={validateOnBlur}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            validateStatus={errorObj && errorObj.vehiclePrice ? "error" : ""}
            help={errorObj && errorObj.vehiclePrice}
            colon={false}
            label={<Text>Exchange Price</Text>}
          >
            {getFieldDecorator("vehiclePrice")(
              <Input
                addonBefore="&#8377;"
                disabled={!editable || vehiclePropsVisblity || bookingAuthStatus}
                placeholder="Exchange Price"
                onKeyUp={(e) => form.setFieldsValue({ vehiclePrice: formatValue(e, "noWithDot") })}
                pattern="[0-9]+(\.[0-9][0-9]?)?"
                onInput={(event) => {
                  if (!event.target.checkValidity()) {
                    setErrorObj({ ...errorObj, vehiclePrice: "Enter Valid Price" });
                  } else {
                    delete errorObj.vehiclePrice;
                  }
                }}
                onBlur={(e) => {
                  validateOnBlur();
                  const finalAmount = parseFloat(getFieldValue("finalAmount") || 0);
                  updateNetReceivables(finalAmount);
                  addFinalAmount({ target: { value: 0 } });
                }}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
      <br />
      <Text strong>Vehicle Charges</Text>
      <Row type="flex" justify="space-between">
        <Col span={7}>
          <Form.Item colon={false} label={<Text>On-Road Price</Text>}>
            {getFieldDecorator("onRoadPrice")(
              <Input
                addonBefore="&#8377;"
                onKeyUp={(e) => form.setFieldsValue({ onRoadPrice: formatValue(e, "noWithDot") })}
                disabled={true}
                placeholder="On-Road Price"
              />
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            validateStatus={errorObj && errorObj.TRcharges ? "error" : ""}
            help={errorObj && errorObj.TRcharges}
            colon={false}
            label={<Text>Temporary Registration Charges</Text>}
          >
            {getFieldDecorator("TRcharges")(
              <Input
                addonBefore="&#8377;"
                disabled={!editable || vehiclePropsVisblity || bookingAuthStatus}
                placeholder="Temporary Registration Charges"
                onKeyUp={(e) => form.setFieldsValue({ TRcharges: formatValue(e, "noWithDot") })}
                pattern="[0-9]+(\.[0-9][0-9]?)?"
                onInput={(event) => {
                  if (!event.target.checkValidity()) {
                    setErrorObj({ ...errorObj, TRcharges: "Enter Valid Price" });
                  } else {
                    delete errorObj.TRcharges;
                  }
                }}
                onBlur={(e) => {
                  validateOnBlur();
                  addFinalAmount({ target: { value: 0 } });
                }}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            validateStatus={errorObj && errorObj.hypothetication ? "error" : ""}
            help={errorObj && errorObj.hypothetication}
            colon={false}
            label={<Text>Hypothetication</Text>}
          >
            {getFieldDecorator("hypothetication")(
              <Input
                addonBefore="&#8377;"
                disabled={!editable || vehiclePropsVisblity || bookingAuthStatus}
                placeholder="Hypothetication"
                onKeyUp={(e) => form.setFieldsValue({ hypothetication: formatValue(e, "noWithDot") })}
                pattern="[0-9]+(\.[0-9][0-9]?)?"
                onInput={(event) => {
                  if (!event.target.checkValidity()) {
                    setErrorObj({ ...errorObj, hypothetication: "Enter Valid Price" });
                  } else {
                    delete errorObj.hypothetication;
                  }
                }}
                onBlur={(e) => {
                  validateOnBlur();
                  addFinalAmount({ target: { value: 0 } });
                }}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            validateStatus={errorObj && errorObj.numberPlate ? "error" : ""}
            help={errorObj && errorObj.numberPlate}
            colon={false}
            label={<Text>Number Plate Charges</Text>}
          >
            {getFieldDecorator("numberPlate")(
              <Input
                addonBefore="&#8377;"
                disabled={!editable || vehiclePropsVisblity || bookingAuthStatus}
                placeholder="Number Plate Charges"
                pattern="[0-9]+(\.[0-9][0-9]?)?"
                onInput={(event) => {
                  if (!event.target.checkValidity()) {
                    setErrorObj({ ...errorObj, numberPlate: "Enter Valid Price" });
                  } else {
                    delete errorObj.numberPlate;
                  }
                }}
                onKeyUp={(e) => form.setFieldsValue({ numberPlate: formatValue(e, "noWithDot") })}
                onBlur={(e) => {
                  addFinalAmount(e);
                  validateOnBlur();
                }}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            validateStatus={errorObj && errorObj.affidavitAmount ? "error" : ""}
            help={errorObj && errorObj.affidavitAmount}
            colon={false}
            label={<Text>Affidavit Amount</Text>}
          >
            {getFieldDecorator("affidavitAmount")(
              <Input
                addonBefore="&#8377;"
                disabled={!editable || vehiclePropsVisblity || bookingAuthStatus}
                placeholder="Affidavit Amount"
                onKeyUp={(e) => form.setFieldsValue({ affidavitAmount: formatValue(e, "noWithDot") })}
                pattern="[0-9]+(\.[0-9][0-9]?)?"
                onInput={(event) => {
                  if (!event.target.checkValidity()) {
                    setErrorObj({ ...errorObj, affidavitAmount: "Enter Valid Price" });
                  } else {
                    delete errorObj.affidavitAmount;
                  }
                }}
                onBlur={(e) => {
                  validateOnBlur();
                  addFinalAmount({ target: { value: 0 } });
                }}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            validateStatus={errorObj && errorObj.specialNoCharges ? "error" : ""}
            help={errorObj && errorObj.specialNoCharges}
            colon={false}
            label={<Text>Special No. Charges</Text>}
          >
            {getFieldDecorator("specialNoCharges")(
              <Input
                addonBefore="&#8377;"
                disabled={!editable || vehiclePropsVisblity || bookingAuthStatus}
                placeholder="Special No. Charges"
                onKeyUp={(e) => form.setFieldsValue({ specialNoCharges: formatValue(e, "noWithDot") })}
                pattern="[0-9]+(\.[0-9][0-9]?)?"
                onInput={(event) => {
                  if (!event.target.checkValidity()) {
                    setErrorObj({ ...errorObj, specialNoCharges: "Enter Valid Price" });
                  } else {
                    delete errorObj.specialNoCharges;
                  }
                }}
                onBlur={(e) => {
                  validateOnBlur();
                  addFinalAmount({ target: { value: 0 } });
                }}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row type="flex" justify="space-between">
        <Col span={7}>
          <Form.Item
            validateStatus={errorObj && errorObj.onRoadDiscount ? "error" : ""}
            help={errorObj && errorObj.onRoadDiscount}
            colon={false}
            label={<Text>On Road Discount</Text>}
          >
            {getFieldDecorator("onRoadDiscount")(
              <Input
                addonBefore="&#8377;"
                onKeyUp={(e) => form.setFieldsValue({ onRoadDiscount: formatValue(e, "noWithDot") })}
                disabled={!editable || vehiclePropsVisblity || bookingAuthStatus}
                placeholder="Final Discount (for On-Road)"
                pattern="[0-9]+(\.[0-9][0-9]?)?"
                onInput={(event) => {
                  if (!event.target.checkValidity()) {
                    setErrorObj({ ...errorObj, onRoadDiscount: "Enter Valid Price" });
                  } else {
                    delete errorObj.onRoadDiscount;
                  }
                }}
                onBlur={(e) => {
                  validateOnBlur();
                  addFinalAmount({ target: { value: 0 } });
                }}
              />
            )}
          </Form.Item>
        </Col>

        {/* ── Expected Delivery Date ── MANDATORY for ALL modes ── */}
        <Col span={7}>
          <Form.Item
            colon={false}
            required={true}
            label={<Text>Expected Delivery Date</Text>}
          >
            {getFieldDecorator("expectedDeliveryDate", {
              rules: [
                {
                  required: true,
                  message: "Please select expected delivery date!",
                },
              ],
              initialValue: data?.expectedDeliveryDate
                ? moment(data.expectedDeliveryDate)
                : null,
            })(
              <DatePicker
                format="DD-MM-YYYY"
                disabled={!editable || bookingAuthStatus}
                style={{ width: "100%" }}
                placeholder="Select Expected Delivery Date"
                disabledDate={(current) => current && current < moment().startOf("day")}
              />
            )}
          </Form.Item>
        </Col>

        <Col span={7}>
          <Form.Item colon={false} label={<Text>Final Amount</Text>}>
            <Row>
              <Col span={24}>
                {getFieldDecorator("finalAmount")(
                  <Input
                    addonBefore="&#8377;"
                    disabled={true}
                    onKeyUp={(e) => form.setFieldsValue({ finalAmount: formatValue(e, "noWithDot") })}
                    placeholder="Final Amount"
                    onBlur={validateOnBlur}
                  />
                )}
              </Col>
            </Row>
          </Form.Item>
        </Col>
      </Row>
      <AccessoryModal
        modalData={data}
        emitData={(data) => addData(data)}
        editable={editFlag}
        accessoriesData={accessoriesData}
        initialData={dataSource}
        open={addFlag}
        close={() => {
          setSelected(null);
          setAddFlag(false);
        }}
      />
      <VehicleModal
        data={getVehicleModalData()}
        dataColor={dataColor}
        emitData={addVehicle}
        open={chooseModalFlag}
        editable={editable}
        bhSeries={bhSeries}
        close={() => {
          setSelectedz(-1);
          setChooseModalFlag(false);
        }}
      />
    </Form>
  );
};

const WrappedVehicleData = Form.create()(VehicleData);
export default WrappedVehicleData;